<template>
  <vx-card id="app_body" class="flex-1 flex-col w-full lg:ml-base relative ">
    <template slot="no-body">
      <global-header :buttonBack="true" :actions="false"></global-header>
      <div class="w-full p-5 ">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              label="Nomor Surat"
              class="w-full"
              placeholder="Misalkan : 102/153/DPMPTSP/IV/2020"
              v-model="input.nomor"
              name="nomor"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('nomor')">{{
              errors.first("nomor")
            }}</span>
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              label="Nomor Urut Surat"
              class="w-full"
              type="number"
              placeholder="Misalkan : 102"
              v-model="input.angka"
              name="angka"
              v-validate="{required: true, regex: /^([0-9]+)$/}"
            />
            <span class="text-danger text-sm" v-show="errors.has('angka')">{{
              errors.first("angka")
            }}</span>
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-select
              placeholder="Kode Surat"
              :options="kodeSuratModifier"
              class="w-full"
              v-model="input.kode_surat"
              label="nama"
              :reduce="kodeSuratModifier => kodeSuratModifier.value"
              name="kode_surat"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('kode_surat')"
              >{{ errors.first("kode_surat") }}</span
            >
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <datepicker
              v-model="input.tanggal"
              :format="'yyyy-MM-dd'"
              placeholder="Tanggal Nomor"
              name="tanggal"
              v-validate="'required'"
            >
            </datepicker>
            <span class="text-danger text-sm" v-show="errors.has('tanggal')">{{
              errors.first("tanggal")
            }}</span>
          </div>
        </div>

        <div class="vx-row mt-8">
          <div class="vx-col w-full">
            <vs-radio
              name="tipe_surat"
              v-model="input.tipe"
              vs-value="surat_masuk"
              class="mr-4"
              vs-name="layout-type-vertical"
              v-validate="'required'"
            >
              Surat Masuk
            </vs-radio>
            <vs-radio
              name="tipe_surat"
              v-model="input.tipe"
              vs-value="surat_keluar"
              class="mr-4"
              vs-name="layout-type-horizontal"
              v-validate="'required'"
            >
              Surat Keluar
            </vs-radio>
            <br /><span
              class="text-danger text-sm"
              v-show="errors.has('tipe_surat')"
              >{{ errors.first("tipe_surat") }}</span
            >
          </div>
        </div>
        <br />

        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-button @click="submit">Simpan Nomor</vs-button>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import { CREATE } from "@/query/nomor-surat.js";
import { GET_ALL } from "@/query/kode-surat.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  data() {
    return {
      input: {
        nomor: "",
        angka: "",
        tipe: "",
        kode_surat: "",
        tanggal: ""
      },
      kodeSurat: []
    };
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Buat Nomor Surat");
  },
  methods: {
    async submit() {
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.input.tanggal = moment(this.input.tanggal).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.$apollo
            .mutate({
              mutation: CREATE,
              variables: {
                input: {
                  ...this.input
                }
              }
            })
            .then(response => {
              this.$vs.notify({
                title: "Berhasil menambahkan nomor surat baru",
                color: "success",
                iconPack: "feather",
                icon: "icon-x",
                position: "top-right"
              });
              setTimeout(() => {
                this.$router.push({
                  name: "buku-kendali-detail",
                  params: { id: response.data.nomorSuratCreate.uuid }
                });
              }, 700);
            })
            .catch(error => {
              console.error(error);
            });
        } else {
          this.$vs.notify({
            title: "Silahkan lengkapi form terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    }
  },
  apollo: {
    kodeSurat: {
      query: GET_ALL,
      update: data => data.kodeSurat.data,
      variables() {
        return {
          perPage: 10000,
          // orderBy: [{field : "URUTAN", order : "ASC"}],
          where: {
            AND: [{ column: "BISA_DIPILIH", value: 1 }]
          }
        };
      }
    }
  },
  components: {
    "vs-select": vSelect,
    Datepicker
  },
  computed: {
    kodeSuratModifier: function() {
      return this.kodeSurat.map(item => {
        return { value: item.id, nama: `${item.kode_surat} - ${item.nama}` };
      });
    }
  }
};
</script>
